// @flow
export function showMap(): void {
  const map = document.getElementById('map')
  if (map) {
    map.style.display = 'block'
  }
}